import { publicRequest } from "@/services";
import { Flex, Typography } from "antd";
import _ from "lodash";
import React, { useCallback, useEffect } from "react";

const onRequestVerifiedCode = async (code: string, email: string) => {
  try {
    await publicRequest<any, any>({
      url: `/qr-verified?code=${code}&email=${email}`,
      method: "POST",
    });

    console.log("Success!!");
  } catch (error) {
    console.log(error);
  }
};

const onClose = async () => {
  window.opener = null;
  window.open('', '_self');
  window.close();
}

const QRVerified: React.FC = () => {
  const queryString = new URLSearchParams(window.location.search);

  const code = _.defaultTo(queryString.get("code"), "");
  const email = _.defaultTo(queryString.get("email"), "");

  const onVerify = useCallback(async () => {
    await onRequestVerifiedCode(code, email);
  }, [code, email]);

  useEffect(() => {
    onVerify();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    
    var timerId = setTimeout(() => {
      onClose();
    }, 2000);
    
    return () => clearTimeout(timerId);
  }, []);

  return (
    <Flex gap="middle" align="center" vertical>
      <Typography.Text style={{ fontSize: 24, color: "#40C1A2" }}>
        Verifying...
      </Typography.Text>
    </Flex>
  );
};

export default QRVerified;
